function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Alert, Select, InputNumber, Modal, Upload, message, Tabs } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import Common from '../includes/Common';
import Webcam from "react-webcam";
import { Paperclip, CameraFill, HandIndexFill, ArrowClockwise, Upload as UploadIc } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var confirm = Modal.confirm;
var AddBankTransaction = function AddBankTransaction(_ref) {
  var cashBox = _ref.cashBox,
    operationType = _ref.operationType,
    handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    cecOptions = _useState8[0],
    setCecOptions = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    proofImage = _useState0[0],
    setProofImage = _useState0[1];
  var _useState1 = useState(1),
    _useState10 = _slicedToArray(_useState1, 2),
    proofType = _useState10[0],
    setProofType = _useState10[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var props = {
    onRemove: function onRemove(file) {
      setProofImage(null);
    },
    beforeUpload: function beforeUpload(file) {
      setProofImage(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  var handleProofTabChange = function handleProofTabChange(key) {
    setProofType(key);
  };
  var onFinish = function onFinish(values) {
    confirm({
      title: 'Confirmez-vous ?',
      content: "L'opération dépot banque de " + values.amount.toLocaleString('Fr') + " GNF",
      onOk: function onOk() {
        setIsFormLoading(true);
        var formData = new FormData();
        formData.append('amount', values.amount);
        formData.append('comment', values.comment);
        formData.append('user_id', Common.currentUser.id);
        formData.append('operation_type', operationType);
        formData.append('proof_type', proofType.toString());
        formData.append('expense_category_id', null);
        formData.append('proof', proofImage);
        axios.post("".concat(Common.baseApiUrl, "addbankdeposit"), formData).then(function (response) {
          if (response.data.status == 200) {
            handler();
          } else {
            message.error({
              content: response.data.message,
              delay: 4
            });
          }
        })["catch"](function (error) {
          message.error({
            content: 'Une erreur est survenue',
            delay: 4
          });
        })["finally"](function () {
          setIsFormLoading(false);
        });
      }
    });
  };
  var tabItems = [{
    key: 1,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(Paperclip, {
        size: 25
      }), " FICHIER JOINT"]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
        children: /*#__PURE__*/_jsx(Button, {
          type: "primary",
          icon: /*#__PURE__*/_jsx(UploadIc, {
            size: 20
          }),
          children: /*#__PURE__*/_jsx("b", {
            children: "Joindre le courrier"
          })
        })
      }))
    })
  }, {
    key: 2,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CameraFill, {
        size: 25
      }), " APPAREIL PHOTO"]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: proofImage == null ? /*#__PURE__*/_jsx(Webcam, {
        audio: false,
        height: 300,
        mirrored: true,
        screenshotFormat: "image/png",
        width: 380,
        children: function children(_ref2) {
          var getScreenshot = _ref2.getScreenshot;
          return /*#__PURE__*/_jsx(Button, {
            type: "default",
            icon: /*#__PURE__*/_jsx(HandIndexFill, {
              size: 22
            }),
            onClick: function onClick() {
              var imageSrc = getScreenshot();
              setProofImage(imageSrc);
            },
            children: "Capturer le pi\xE8ce"
          });
        }
      }) : /*#__PURE__*/_jsxs("div", {
        style: {
          width: '380px'
        },
        children: [/*#__PURE__*/_jsx("img", {
          src: proofImage
        }), /*#__PURE__*/_jsx(Button, {
          type: "default",
          onClick: function onClick() {
            setProofImage(null);
          },
          icon: /*#__PURE__*/_jsx(ArrowClockwise, {
            size: 20
          }),
          children: /*#__PURE__*/_jsx("b", {
            children: "Reprendre"
          })
        })]
      })
    })
  }];
  useEffect(function () {
    form.setFieldsValue({
      comment: ''
    });
    axios.get("".concat(Common.baseApiUrl, "getexepensecategories/").concat(Common.currentUser.id)).then(function (response) {
      if (response.data.status == 200) {
        setCecOptions([]);
        response.data.categories.forEach(function (c) {
          setCecOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: c.label
            }]);
          });
        });
        if (response.data.categories.length > 0) form.setFieldsValue({
          expense_category_id: response.data.categories[0].id
        });
      } else {
        message.error({
          content: 'Aucune catégorie de dépense dans le système',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Aucune catégorie de dépense dans le système',
        delay: 4
      });
    })["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      onFinish: onFinish,
      form: form,
      layout: "vertical",
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "amount",
        label: "Montant",
        rules: [{
          required: true,
          'message': 'Ce champ est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "GNF",
          style: {
            width: '200px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), operationType == 0 && /*#__PURE__*/_jsx(Form.Item, {
        label: "Cat\xE9gorie",
        name: "expense_category_id",
        rules: [{
          required: true,
          message: 'Ce champ est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Select, {
          options: cecOptions
        })
      }), /*#__PURE__*/_jsx(Tabs, {
        destroyInactiveTabPane: true,
        onChange: handleProofTabChange,
        items: tabItems
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Form.Item, {
        name: "comment",
        label: "Motif",
        rules: [{
          required: true,
          message: 'Ce champ est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(TextArea, {
          autoSize: true
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          disabled: cecOptions.length == 0 && operationType == 0,
          loading: isFormLoading,
          type: "primary",
          htmlType: "submit",
          children: /*#__PURE__*/_jsx("b", {
            children: "VALIDER"
          })
        })
      })]
    })]
  });
};
export default AddBankTransaction;